import { Card, Footer, Header, Main, PlainSkeleton } from "@/components";

export const GateSkeleton = () => {
  return (
    <>
      <Header>デバイス詳細</Header>
      <Main>
        <Card>
          <PlainSkeleton />
        </Card>
      </Main>
      <Footer />
    </>
  );
};
